module.exports = __webpack_public_path__ + "img/zqyhicon.748b9d71.svg";